import { firebase } from '../config/configureFirebase';
import { ref, push, set, onValue, off, update, remove, query, orderByChild, limitToLast } from "firebase/database";

// ===== COMMUNITY CHAT =====
export const fetchCommunityChat = () => (dispatch) => {
  const chatRef = query(ref(firebase.database, 'community_chat'), orderByChild('createdAt'), limitToLast(100));
  onValue(chatRef, (snap) => {
    let messages = [];
    if (snap.val()) {
      Object.keys(snap.val()).forEach(key => {
        messages.push({ id: key, ...snap.val()[key] });
      });
    }
    dispatch({ type: 'COMMUNITY_CHAT_LOADED', payload: messages });
  });
};

export const sendCommunityMessage = (message) => (dispatch) => {
  const chatRef = ref(firebase.database, 'community_chat');
  push(chatRef, { ...message, createdAt: new Date().getTime() });
};

export const deleteCommunityMessage = (msgId) => (dispatch) => {
  remove(ref(firebase.database, 'community_chat/' + msgId));
};

export const pinCommunityMessage = (msgId, pinned) => (dispatch) => {
  update(ref(firebase.database, 'community_chat/' + msgId), { pinned });
};

export const reportCommunityMessage = (msgId, reportData) => (dispatch) => {
  const reportRef = ref(firebase.database, 'community_reports');
  push(reportRef, { messageId: msgId, ...reportData, createdAt: new Date().getTime() });
};

// ===== ANNOUNCEMENTS =====
export const fetchAnnouncements = () => (dispatch) => {
  const annRef = query(ref(firebase.database, 'community_announcements'), orderByChild('createdAt'), limitToLast(50));
  onValue(annRef, (snap) => {
    let items = [];
    if (snap.val()) {
      Object.keys(snap.val()).forEach(key => {
        items.push({ id: key, ...snap.val()[key] });
      });
    }
    dispatch({ type: 'ANNOUNCEMENTS_LOADED', payload: items });
  });
};

export const addAnnouncement = (data) => (dispatch) => {
  const annRef = ref(firebase.database, 'community_announcements');
  push(annRef, { ...data, createdAt: new Date().getTime() });
};

export const deleteAnnouncement = (id) => (dispatch) => {
  remove(ref(firebase.database, 'community_announcements/' + id));
};

// ===== DRIVER ACADEMY =====
export const fetchAcademyContent = () => (dispatch) => {
  const acadRef = ref(firebase.database, 'driver_academy');
  onValue(acadRef, (snap) => {
    let categories = [];
    if (snap.val()) {
      Object.keys(snap.val()).forEach(key => {
        categories.push({ id: key, ...snap.val()[key] });
      });
    }
    dispatch({ type: 'ACADEMY_LOADED', payload: categories });
  });
};

export const addAcademyCategory = (data) => (dispatch) => {
  const acadRef = ref(firebase.database, 'driver_academy');
  push(acadRef, { ...data, createdAt: new Date().getTime() });
};

export const updateAcademyCategory = (id, data) => (dispatch) => {
  update(ref(firebase.database, 'driver_academy/' + id), data);
};

export const deleteAcademyCategory = (id) => (dispatch) => {
  remove(ref(firebase.database, 'driver_academy/' + id));
};

// ===== TRAFFIC UPDATES =====
export const fetchTrafficReports = () => (dispatch) => {
  const tRef = query(ref(firebase.database, 'traffic_reports'), orderByChild('createdAt'), limitToLast(50));
  onValue(tRef, (snap) => {
    let reports = [];
    if (snap.val()) {
      Object.keys(snap.val()).forEach(key => {
        reports.push({ id: key, ...snap.val()[key] });
      });
    }
    dispatch({ type: 'TRAFFIC_REPORTS_LOADED', payload: reports });
  });
};

export const addTrafficReport = (data) => (dispatch) => {
  const tRef = ref(firebase.database, 'traffic_reports');
  push(tRef, { ...data, createdAt: new Date().getTime() });
};

export const deleteTrafficReport = (id) => (dispatch) => {
  remove(ref(firebase.database, 'traffic_reports/' + id));
};

// ===== NEARBY FOOD =====
export const fetchFoodSpots = () => (dispatch) => {
  const fRef = ref(firebase.database, 'food_spots');
  onValue(fRef, (snap) => {
    let spots = [];
    if (snap.val()) {
      Object.keys(snap.val()).forEach(key => {
        spots.push({ id: key, ...snap.val()[key] });
      });
    }
    dispatch({ type: 'FOOD_SPOTS_LOADED', payload: spots });
  });
};

export const addFoodSpot = (data) => (dispatch) => {
  const fRef = ref(firebase.database, 'food_spots');
  push(fRef, { ...data, createdAt: new Date().getTime() });
};

export const updateFoodSpot = (id, data) => (dispatch) => {
  update(ref(firebase.database, 'food_spots/' + id), data);
};

export const deleteFoodSpot = (id) => (dispatch) => {
  remove(ref(firebase.database, 'food_spots/' + id));
};

// ===== LOST & FOUND =====
export const fetchLostFound = () => (dispatch) => {
  const lfRef = query(ref(firebase.database, 'lost_found'), orderByChild('createdAt'), limitToLast(50));
  onValue(lfRef, (snap) => {
    let items = [];
    if (snap.val()) {
      Object.keys(snap.val()).forEach(key => {
        items.push({ id: key, ...snap.val()[key] });
      });
    }
    dispatch({ type: 'LOST_FOUND_LOADED', payload: items });
  });
};

export const addLostFoundItem = (data) => (dispatch) => {
  const lfRef = ref(firebase.database, 'lost_found');
  push(lfRef, { ...data, status: 'reported', createdAt: new Date().getTime() });
};

export const updateLostFoundStatus = (id, status) => (dispatch) => {
  update(ref(firebase.database, 'lost_found/' + id), { status, updatedAt: new Date().getTime() });
};

export const deleteLostFoundItem = (id) => (dispatch) => {
  remove(ref(firebase.database, 'lost_found/' + id));
};

// ===== EMERGENCY =====
export const sendEmergencyAlert = (data) => (dispatch) => {
  const eRef = ref(firebase.database, 'emergency_alerts');
  push(eRef, { ...data, status: 'active', createdAt: new Date().getTime() });
};

export const fetchEmergencyAlerts = () => (dispatch) => {
  const eRef = query(ref(firebase.database, 'emergency_alerts'), orderByChild('createdAt'), limitToLast(50));
  onValue(eRef, (snap) => {
    let alerts = [];
    if (snap.val()) {
      Object.keys(snap.val()).forEach(key => {
        alerts.push({ id: key, ...snap.val()[key] });
      });
    }
    dispatch({ type: 'EMERGENCY_ALERTS_LOADED', payload: alerts });
  });
};

export const resolveEmergencyAlert = (id) => (dispatch) => {
  update(ref(firebase.database, 'emergency_alerts/' + id), { status: 'resolved', resolvedAt: new Date().getTime() });
};

// ===== COMMUNITY POLLS =====
export const fetchPolls = () => (dispatch) => {
  const pRef = ref(firebase.database, 'community_polls');
  onValue(pRef, (snap) => {
    let polls = [];
    if (snap.val()) {
      Object.keys(snap.val()).forEach(key => {
        polls.push({ id: key, ...snap.val()[key] });
      });
    }
    dispatch({ type: 'POLLS_LOADED', payload: polls });
  });
};

export const addPoll = (data) => (dispatch) => {
  const pRef = ref(firebase.database, 'community_polls');
  push(pRef, { ...data, createdAt: new Date().getTime() });
};

export const votePoll = (pollId, optionIndex, uid) => (dispatch) => {
  const voteRef = ref(firebase.database, 'community_polls/' + pollId + '/votes/' + uid);
  set(voteRef, optionIndex);
};

export const deletePoll = (id) => (dispatch) => {
  remove(ref(firebase.database, 'community_polls/' + id));
};

// ===== DRIVER ACHIEVEMENTS =====
export const fetchAchievements = () => (dispatch) => {
  const aRef = ref(firebase.database, 'driver_achievements');
  onValue(aRef, (snap) => {
    let items = [];
    if (snap.val()) {
      Object.keys(snap.val()).forEach(key => {
        items.push({ id: key, ...snap.val()[key] });
      });
    }
    dispatch({ type: 'ACHIEVEMENTS_LOADED', payload: items });
  });
};

export const awardAchievement = (driverId, badge) => (dispatch) => {
  const aRef = ref(firebase.database, 'driver_achievements/' + driverId + '/badges');
  push(aRef, { ...badge, awardedAt: new Date().getTime() });
};

// ===== DRIVER MARKETPLACE =====
export const fetchMarketplace = () => (dispatch) => {
  const mRef = query(ref(firebase.database, 'driver_marketplace'), orderByChild('createdAt'), limitToLast(50));
  onValue(mRef, (snap) => {
    let items = [];
    if (snap.val()) {
      Object.keys(snap.val()).forEach(key => {
        items.push({ id: key, ...snap.val()[key] });
      });
    }
    dispatch({ type: 'MARKETPLACE_LOADED', payload: items });
  });
};

export const addMarketplaceItem = (data) => (dispatch) => {
  const mRef = ref(firebase.database, 'driver_marketplace');
  push(mRef, { ...data, status: 'active', createdAt: new Date().getTime() });
};

export const updateMarketplaceItem = (id, data) => (dispatch) => {
  update(ref(firebase.database, 'driver_marketplace/' + id), data);
};

export const deleteMarketplaceItem = (id) => (dispatch) => {
  remove(ref(firebase.database, 'driver_marketplace/' + id));
};

// ===== MARKETPLACE MESSAGING =====
export const fetchMarketplaceMessages = (conversationId) => (dispatch) => {
  const msgRef = query(ref(firebase.database, 'marketplace_messages/' + conversationId), orderByChild('createdAt'), limitToLast(100));
  onValue(msgRef, (snap) => {
    let messages = [];
    if (snap.val()) {
      Object.keys(snap.val()).forEach(key => {
        messages.push({ id: key, ...snap.val()[key] });
      });
    }
    dispatch({ type: 'MARKETPLACE_MESSAGES_LOADED', payload: { conversationId, messages } });
  });
};

export const sendMarketplaceMessage = (conversationId, data) => (dispatch) => {
  const msgRef = ref(firebase.database, 'marketplace_messages/' + conversationId);
  push(msgRef, { ...data, createdAt: new Date().getTime() });
  // Update conversation metadata
  update(ref(firebase.database, 'marketplace_conversations/' + conversationId), {
    lastMessage: data.text,
    lastMessageAt: new Date().getTime(),
    buyerId: data.buyerId || '',
    buyerName: data.buyerName || '',
    sellerId: data.sellerId || '',
    sellerName: data.sellerName || '',
    itemId: data.itemId || '',
    itemTitle: data.itemTitle || '',
  });
};

export const fetchMyConversations = (uid) => (dispatch) => {
  const convRef = ref(firebase.database, 'marketplace_conversations');
  onValue(convRef, (snap) => {
    let convos = [];
    if (snap.val()) {
      Object.keys(snap.val()).forEach(key => {
        const c = snap.val()[key];
        if (c.buyerId === uid || c.sellerId === uid) {
          convos.push({ id: key, ...c });
        }
      });
    }
    dispatch({ type: 'MARKETPLACE_CONVERSATIONS_LOADED', payload: convos });
  });
};

// ===== DRIVER EVENTS =====
export const fetchEvents = () => (dispatch) => {
  const evRef = ref(firebase.database, 'driver_events');
  onValue(evRef, (snap) => {
    let items = [];
    if (snap.val()) {
      Object.keys(snap.val()).forEach(key => {
        items.push({ id: key, ...snap.val()[key] });
      });
    }
    dispatch({ type: 'EVENTS_LOADED', payload: items });
  });
};

export const addEvent = (data) => (dispatch) => {
  const evRef = ref(firebase.database, 'driver_events');
  push(evRef, { ...data, createdAt: new Date().getTime() });
};

export const deleteEvent = (id) => (dispatch) => {
  remove(ref(firebase.database, 'driver_events/' + id));
};

// ===== DRIVER REPUTATION BADGES =====
export const REPUTATION_BADGES = [
  { key: 'excellent_communication', label: 'Excellent Communication', icon: 'chat' },
  { key: 'safe_driving', label: 'Safe Driving', icon: 'shield' },
  { key: 'child_friendly', label: 'Child-Friendly', icon: 'child-care' },
  { key: 'pet_friendly', label: 'Pet-Friendly', icon: 'pets' },
  { key: 'speaks_english', label: 'Speaks English', icon: 'translate' },
  { key: 'speaks_cebuano', label: 'Speaks Cebuano', icon: 'record-voice-over' },
  { key: 'wheelchair_assistance', label: 'Wheelchair Assistance', icon: 'accessible' },
];

export const fetchDriverReputation = (uid) => (dispatch) => {
  const repRef = ref(firebase.database, 'users/' + uid + '/reputationBadges');
  onValue(repRef, (snap) => {
    dispatch({ type: 'DRIVER_REPUTATION_LOADED', payload: snap.val() || {} });
  });
};

export const updateDriverReputation = (uid, badges) => (dispatch) => {
  update(ref(firebase.database, 'users/' + uid), { reputationBadges: badges });
};

export const fetchAllDriverReputations = () => (dispatch) => {
  const usersRef = query(ref(firebase.database, 'users'), orderByChild('usertype'), equalTo('driver'));
  onValue(usersRef, (snap) => {
    let drivers = [];
    if (snap.val()) {
      Object.keys(snap.val()).forEach(key => {
        const u = snap.val()[key];
        if (u.reputationBadges) {
          drivers.push({ uid: key, firstName: u.firstName, lastName: u.lastName, reputationBadges: u.reputationBadges });
        }
      });
    }
    dispatch({ type: 'ALL_DRIVER_REPUTATIONS_LOADED', payload: drivers });
  });
};
